import * as React from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';

import { useUserState, useUserActions } from 'contexts/user';
import { APIAccount } from 'apis/index';
import Layout from 'components/common/layout'
import RoutePrivate from 'components/common/route-private';
import { getUserToken, removeUserToken } from 'utils/storage';
import Auth from 'containers/auth';
import Dashboard from 'containers/dashboard'
import GameSetting from 'containers/gameSetting'
import GameManagement from 'containers/gameManagement';
import Products from 'containers/products';
import SearchTool from 'containers/searchTool'
import QA from 'containers/qa'
import ETC from 'containers/etc'
import { config } from 'config';
import Home from './home';

const Wrapper = () => {
  const [ready, setReady] = React.useState(false)

  const { isLogin } = useUserState();
  const { updateUserState, kickUser } = useUserActions();

  const process = async () => {
    await APIAccount.requestAccountToken().then((result: any) => {
      const { user } = result || {}

      !!user && updateUserState(result)
      setReady(true)

    }).catch((err) => {
      removeUserToken()
      kickUser()
      setReady(true)

      window.location.replace('/auth/login');
    })
  }

  React.useEffect(() => {
    getUserToken() ? process() : setReady(true)

    const intervalId = setInterval(() => {
      getUserToken() && process()
    }, 3600000);

    return () => clearInterval(intervalId)
  }, []);


  return ready ? (
    <Router>
      <Layout>
        <Switch>
          <Route path='/auth'>
            <Auth />
          </Route>

          <RoutePrivate permission='VIEWER' path='/home'>
            <Home />
          </RoutePrivate>

          <RoutePrivate permission='VIEWER' path={`/${config.game}/dashboard`}>
            <Dashboard />
          </RoutePrivate>

          <RoutePrivate permission='VIEWER' path={`/${config.game}/gamesetting`}>
            <GameSetting />
          </RoutePrivate>

          <RoutePrivate permission='VIEWER' path={`/${config.game}/gamemanagement`}>
            <GameManagement />
          </RoutePrivate>

          <RoutePrivate permission='VIEWER' path={`/${config.game}/products`}>
            <Products />
          </RoutePrivate>

          <RoutePrivate permission='VIEWER' path={`/${config.game}/searchtool`}>
            <SearchTool />
          </RoutePrivate>

          <RoutePrivate permission='VIEWER' path={`/${config.game}/qa`}>
            <QA />
          </RoutePrivate>

          <RoutePrivate permission='VIEWER' path={`/${config.game}/etc`}>
            <ETC />
          </RoutePrivate>

          <Route path='*'>
            <Redirect to={!isLogin ? '/auth' : '/bingo/dashboard'} />
          </Route>
        </Switch>
      </Layout>
    </Router >) : null;
}

export default Wrapper;
